import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ProjectTargetResult } from '@core/entities/notifications/ProjectTargetResult'
import { TemplateTargetResult } from '@core/entities/notifications/TemplateTargetResult'
import { IPermitTargetResult } from './IPermitTargetResult'

export class PermitTargetResult extends Entity<IPermitTargetResult> {
  id: number
  organisationId: number
  shortUUID: string
  endsOn: string
  summary?: string

  @Type(() => ProjectTargetResult)
  project?: ProjectTargetResult

  @Type(() => TemplateTargetResult)
  template?: TemplateTargetResult

  public static new(payload: IPermitTargetResult): PermitTargetResult {
    return plainToInstance(PermitTargetResult, payload)
  }
}
